import React, { Component } from 'react';
import {
    ImgArea,
    Img,
    Number,
    HeartArea
} from './HeartNumber.style';
import './HeartNumber.scss'
class HeartNumber extends Component {
    // state = {
    //     click  : false
    // }
    // onClick = () =>{
    //     const token = localStorage.getItem("token")
    //     if(!token){
    //         return alert("로그인을 해주세요")
    //     }
    //     this.setState({
    //         click : !this.state.click
    //     })
    // }
    render() {
        const {islikeHeart} = this.props
        return (
            <ImgArea position = {this.props.position}>
                {/* <Number left = {this.props.left}>{this.props.HeartNumber}</Number> */}
                <HeartArea onClick = {this.props.onClick}>
                <span className={islikeHeart && islikeHeart ? "click-heart heart" : "heart"}></span>
                </HeartArea>
                <Number right = {this.props.right}>{this.props.HeartNumber}</Number>
                {/* 나중에 숫자 들어가는곳 디자인 안함 */}
            </ImgArea>
        );
    }
}

export default HeartNumber;